/**
 * A tile appears twice while it is maximized — its grid copy stays mounted at `opacity: 0` —
 * so each copy carries its own id and the board tiles are only spotlightable once every tile
 * is collapsed.
 *
 * The ids without the `planning-` prefix mark elements inside components both cockpits render.
 * Those components take their id as a prop from the cockpit rendering them, so the manager tour
 * targets the same elements by its own names (`managerCockpitTourTargets.ts`). The values here
 * stay as they are because backend tour records may already carry them.
 */
export const PLANNING_COCKPIT_TOUR_TARGETS = {
  partnerDetails: 'planning-cockpit-partner-details',
  salesTeam: 'planning-cockpit-sales-team',
  scopePanel: 'planning-cockpit-scope-panel',
  scopeBar: 'cockpit-scope-bar',
  scopeFiscalYear: 'cockpit-scope-fiscal-year',
  statusCompleteness: 'planning-cockpit-status-completeness',
  statusAcknowledgment: 'planning-cockpit-status-acknowledgment',
  statusPlanQuality: 'planning-cockpit-status-plan-quality',
  scopePeriod: 'cockpit-scope-period',
  scopeMetric: 'cockpit-scope-metric',
  scopeCurrency: 'cockpit-scope-currency',
  trainingCentre: 'planning-cockpit-training-centre',
  programmeTabs: 'planning-cockpit-programme-tabs',
  categoryChip: 'cockpit-category-chip',
  tileRevenue: 'planning-cockpit-tile-revenue',
  tileRevenueExpanded: 'planning-cockpit-tile-revenue-expanded',
  revenueViewSwitch: 'cockpit-revenue-view-switch',
  tileInitiatives: 'planning-cockpit-tile-initiatives',
  tileInitiativesExpanded: 'planning-cockpit-tile-initiatives-expanded',
  initiativesViewSwitch: 'cockpit-initiatives-view-switch',
  tileAttention: 'planning-cockpit-tile-attention',
  tileAttentionExpanded: 'planning-cockpit-tile-attention-expanded',
  tileDocuments: 'planning-cockpit-tile-documents',
  tileDocumentsExpanded: 'planning-cockpit-tile-documents-expanded',
} as const
